var _rect, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcBitfinex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.125,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#03CA9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98686 18.1245C7.83908 15.733 8.84398 13.0746 10.9121 11.0066C15.4096 6.50901 24.7763 7.13897 24.8295 7.14319C24.8042 7.18035 17.9565 17.1078 9.84213 18.0367C9.21555 18.1084 8.59571 18.1372 7.98686 18.1245Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93686 21.1814C9.16908 21.5513 9.4427 21.8966 9.75937 22.2133C12.5359 24.9899 17.5537 24.4739 20.9661 21.0615C25.4772 16.5504 24.8295 7.14316 24.8295 7.14316C24.805 7.19889 19.8962 18.2013 12.0951 20.6012C11.0362 20.9272 9.97469 21.1164 8.93686 21.1814Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBitfinex);
export default __webpack_public_path__ + "static/media/ic_bitfinex.bfae0b321f9c24f25893fb1c11ae50ff.svg";
export { ForwardRef as ReactComponent };